import type { AdItem, AdSlotData } from './ads.types'

// ==============================================
// Mock Ads Registry
// Supports 5 slot locations: hp_hero, hp_bento,
// hp_billboard, pdp_billboard, search_banner
// ==============================================

export const mockAdsData: AdSlotData = {
  // ==============================================
  // HP_HERO - Homepage Hero Carousel
  // ==============================================
  hp_hero: {
    slot_id: 'hp_hero',
    layout_type: 'carousel',
    refresh_interval: 300,
    priority: 1,
    items: [
      {
        id: 'hp_hero_banga',
        desktop_image: '/images/ads/banga.png',
        mobile_image: '/images/ads/banga.png',
        headline: 'Banga Red Palm Oil',
        nav_type: 'detail',
        nav_value: 'banga-red-palm-oil-2kg-premium-african-palm-oil-for-authentic-nigerian-cooking-d9fe00',
        target_categories: ['default'],
        target_keywords: ['default'],
        tracking: {
          pd_rd_w: 'hp_hero',
          pd_rd_wg: 'banga_slot',
          pd_rd_r: generateRequestId(),
        },
      },
      {
        id: 'hp_hero_zenon',
        desktop_image: '/images/ads/zenon.png',
        mobile_image: '/images/ads/zenon.png',
        headline: 'Zenon So-fine Cream',
        nav_type: 'detail',
        nav_value: 'zenon-so-fine-anti-dandruff-hair-darkening-cream-180g-1b0ea6',
        target_categories: ['default'],
        target_keywords: ['default'],
        tracking: {
          pd_rd_w: 'hp_hero',
          pd_rd_wg: 'zenon_slot',
          pd_rd_r: generateRequestId(),
        },
      },
    ],
  },

  // ==============================================
  // HP_BENTO - Homepage Bento Grid (4 items)
  // ==============================================
  hp_bento: {
    slot_id: 'hp_bento',
    layout_type: 'bento',
    refresh_interval: 600,
    priority: 2,
    items: [
      {
        id: 'hp_bento_banga_1',
        desktop_image: '/images/ads/banga.png',
        mobile_image: '/images/ads/banga.png',
        headline: 'Banga Red Palm Oil',
        nav_type: 'detail',
        nav_value: 'banga-red-palm-oil-2kg-premium-african-palm-oil-for-authentic-nigerian-cooking-d9fe00',
        tracking: { pd_rd_w: 'hp_bento', pd_rd_wg: 'banga_slot_1', pd_rd_r: generateRequestId() },
      },
      {
        id: 'hp_bento_zenon_1',
        desktop_image: '/images/ads/zenon.png',
        mobile_image: '/images/ads/zenon.png',
        headline: 'Zenon So-fine Cream',
        nav_type: 'detail',
        nav_value: 'zenon-so-fine-anti-dandruff-hair-darkening-cream-180g-1b0ea6',
        tracking: { pd_rd_w: 'hp_bento', pd_rd_wg: 'zenon_slot_1', pd_rd_r: generateRequestId() },
      },
      {
        id: 'hp_bento_banga_2',
        desktop_image: '/images/ads/banga.png',
        mobile_image: '/images/ads/banga.png',
        headline: 'Banga Red Palm Oil',
        nav_type: 'detail',
        nav_value: 'banga-red-palm-oil-2kg-premium-african-palm-oil-for-authentic-nigerian-cooking-d9fe00',
        tracking: { pd_rd_w: 'hp_bento', pd_rd_wg: 'banga_slot_2', pd_rd_r: generateRequestId() },
      },
      {
        id: 'hp_bento_zenon_2',
        desktop_image: '/images/ads/zenon.png',
        mobile_image: '/images/ads/zenon.png',
        headline: 'Zenon So-fine Cream',
        nav_type: 'detail',
        nav_value: 'zenon-so-fine-anti-dandruff-hair-darkening-cream-180g-1b0ea6',
        tracking: { pd_rd_w: 'hp_bento', pd_rd_wg: 'zenon_slot_2', pd_rd_r: generateRequestId() },
      },
    ],
  },

  // ==============================================
  // HP_BILLBOARD_1 - Homepage Billboard (After New Arrivals)
  // ==============================================
  hp_billboard_1: {
    slot_id: 'hp_billboard_1',
    layout_type: 'billboard',
    refresh_interval: 600,
    priority: 2,
    items: [
      {
        id: 'hp_billboard_1_item',
        desktop_image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=600&q=40&auto=format',
        mobile_image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=600&q=40&auto=format',
        headline: 'Exquisite Jewelry & Accessories',
        description: 'Elevate your style with our handcrafted jewelry pieces.',
        cta_text: 'Shop Jewelry',
        nav_type: 'browse',
        nav_value: 'jewelry-accessories',
        tracking: {
          pd_rd_w: 'hp_billboard_1',
          pd_rd_wg: 'banga_slot',
          pd_rd_r: generateRequestId(),
        },
      },
    ],
  },

  // ==============================================
  // HP_BILLBOARD_2 - Homepage Billboard (After Limited Stock)
  // ==============================================
  hp_billboard_2: {
    slot_id: 'hp_billboard_2',
    layout_type: 'billboard',
    refresh_interval: 600,
    priority: 2,
    items: [
      {
        id: 'hp_billboard_2_item',
        desktop_image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&q=40&auto=format',
        mobile_image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&q=40&auto=format',
        headline: 'Free Shipping on Orders',
        description: 'Plus easy 14-day returns. Shop with confidence knowing your satisfaction is guaranteed.',
        cta_text: 'Start Shopping',
        nav_type: 'browse',
        nav_value: '',
        tracking: {
          pd_rd_w: 'hp_billboard_2',
          pd_rd_wg: 'zenon_slot',
          pd_rd_r: generateRequestId(),
        },
      },
    ],
  },

  // ==============================================
  // HP_BILLBOARD_3 - Homepage Billboard (After Top Purchased)
  // ==============================================
  hp_billboard_3: {
    slot_id: 'hp_billboard_3',
    layout_type: 'billboard',
    refresh_interval: 600,
    priority: 2,
    items: [
      {
        id: 'hp_billboard_3_item',
        desktop_image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=600&q=40&auto=format',
        mobile_image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=600&q=40&auto=format',
        headline: 'Unique Arts & Crafts',
        description: 'Discover one-of-a-kind handcrafted pieces and collectibles.',
        cta_text: 'Shop Arts',
        nav_type: 'browse',
        nav_value: 'arts-crafts-collectibles',
        tracking: {
          pd_rd_w: 'hp_billboard_3',
          pd_rd_wg: 'banga_slot',
          pd_rd_r: generateRequestId(),
        },
      },
    ],
  },

  // ==============================================
  // HP_BILLBOARD_4 - Homepage Billboard (After Mouth Watering)
  // ==============================================
  hp_billboard_4: {
    slot_id: 'hp_billboard_4',
    layout_type: 'billboard',
    refresh_interval: 600,
    priority: 2,
    items: [
      {
        id: 'hp_billboard_4_item',
        desktop_image: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=600&q=40&auto=format',
        mobile_image: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=600&q=40&auto=format',
        headline: 'Trending Shop Much More Picks',
        description: 'Explore the most popular items our community loves.',
        cta_text: 'Explore Trending',
        nav_type: 'browse',
        nav_value: '',
        tracking: {
          pd_rd_w: 'hp_billboard_4',
          pd_rd_wg: 'zenon_slot',
          pd_rd_r: generateRequestId(),
        },
      },
    ],
  },

  // ==============================================
  // HP_BILLBOARD_5 - Homepage Billboard 5
  // ==============================================
  hp_billboard_5: {
    slot_id: 'hp_billboard_5',
    layout_type: 'billboard',
    refresh_interval: 600,
    priority: 2,
    items: [
      {
        id: 'hp_billboard_5_item',
        desktop_image: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?w=600&q=40&auto=format',
        mobile_image: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?w=600&q=40&auto=format',
        headline: 'Exclusive Home Decor',
        description: 'Upgrade your living space with our premium selection.',
        cta_text: 'Shop Home',
        nav_type: 'browse',
        nav_value: 'home-living-decor',
        tracking: {
          pd_rd_w: 'hp_billboard_5',
          pd_rd_wg: 'banga_slot',
          pd_rd_r: generateRequestId(),
        },
      },
    ],
  },

  // ==============================================
  // PDP_BILLBOARD - Product Detail Page Billboard
  // Context-aware: filters by categoryId
  // ==============================================
  pdp_billboard: {
    slot_id: 'pdp_billboard',
    layout_type: 'billboard',
    refresh_interval: 900,
    priority: 3,
    // Context metadata for filtering
    context_filters: {
      type: 'category',
      field: 'target_categories',
    },
    items: [
      {
        id: 'pdp_billboard_banga',
        desktop_image: '/images/ads/banga.png',
        mobile_image: '/images/ads/banga.png',
        headline: 'Banga Red Palm Oil',
        nav_type: 'detail',
        nav_value: 'banga-red-palm-oil-2kg-premium-african-palm-oil-for-authentic-nigerian-cooking-d9fe00',
        target_categories: ['default'],
        target_keywords: ['default'],
        tracking: {
          pd_rd_w: 'pdp_billboard',
          pd_rd_wg: 'banga_slot',
          pd_rd_r: generateRequestId(),
        },
      },
      {
        id: 'pdp_billboard_zenon',
        desktop_image: '/images/ads/zenon.png',
        mobile_image: '/images/ads/zenon.png',
        headline: 'Zenon So-fine Cream',
        nav_type: 'detail',
        nav_value: 'zenon-so-fine-anti-dandruff-hair-darkening-cream-180g-1b0ea6',
        target_categories: ['default'],
        target_keywords: ['default'],
        tracking: {
          pd_rd_w: 'pdp_billboard',
          pd_rd_wg: 'zenon_slot',
          pd_rd_r: generateRequestId(),
        },
      },
    ],
  },
}

// ==============================================
// Helper Functions
// ==============================================

/**
 * Generates a unique Amazon-style request ID
 */
function generateRequestId(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  const segments = [8, 4, 4, 4, 12]
  return segments
    .map((len) => Array.from({ length: len }, () => chars[Math.floor(Math.random() * chars.length)]).join(''))
    .join('-')
}

/**
 * Filter items by category context
 */
export function filterItemsByCategory(items: AdItem[], categoryId?: string): AdItem[] {
  if (!categoryId) {
    // Return default item if no category provided
    const defaultItem = items.find((item) =>
      (item as AdItem & { target_categories?: string[] }).target_categories?.includes('default'),
    )
    return defaultItem ? [defaultItem] : items.slice(0, 1)
  }

  const lowerCategoryId = categoryId.toLowerCase()

  // Find matching item by category
  const matchingItem = items.find((item) => {
    const targetCategories = (item as AdItem & { target_categories?: string[] }).target_categories
    return targetCategories?.some((cat) => lowerCategoryId.includes(cat) || cat.includes(lowerCategoryId))
  })

  if (matchingItem) {
    return [matchingItem]
  }

  // Fallback to default
  const defaultItem = items.find((item) =>
    (item as AdItem & { target_categories?: string[] }).target_categories?.includes('default'),
  )
  return defaultItem ? [defaultItem] : items.slice(0, 1)
}

/**
 * Filter items by search query keywords
 */
export function filterItemsByKeyword(items: AdItem[], query?: string): AdItem[] {
  if (!query) {
    // Return default item if no query provided
    const defaultItem = items.find((item) =>
      (item as AdItem & { target_keywords?: string[] }).target_keywords?.includes('default'),
    )
    return defaultItem ? [defaultItem] : items.slice(0, 1)
  }

  const lowerQuery = query.toLowerCase()
  const queryWords = lowerQuery.split(/\s+/)

  // Find matching item by keyword
  const matchingItem = items.find((item) => {
    const targetKeywords = (item as AdItem & { target_keywords?: string[] }).target_keywords
    return targetKeywords?.some((keyword) =>
      queryWords.some((word) => word.includes(keyword) || keyword.includes(word)),
    )
  })

  if (matchingItem) {
    return [matchingItem]
  }

  // Fallback to default
  const defaultItem = items.find((item) =>
    (item as AdItem & { target_keywords?: string[] }).target_keywords?.includes('default'),
  )
  return defaultItem ? [defaultItem] : items.slice(0, 1)
}

// ==============================================
// Slot Constants
// ==============================================

export const AD_SLOTS = {
  HP_HERO: 'hp_hero',
  HP_BENTO: 'hp_bento',
  HP_BILLBOARD_1: 'hp_billboard_1',
  HP_BILLBOARD_2: 'hp_billboard_2',
  HP_BILLBOARD_3: 'hp_billboard_3',
  HP_BILLBOARD_4: 'hp_billboard_4',
  HP_BILLBOARD_5: 'hp_billboard_5',
  PDP_BILLBOARD: 'pdp_billboard',
  SEARCH_BANNER: 'search_banner',
} as const

export type AdSlotName = (typeof AD_SLOTS)[keyof typeof AD_SLOTS]
